var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { defineMessages, injectIntl } from "react-intl";
import Sport from "./Sport";
import { Link } from "react-router-dom";
import { sportSortFunc } from "../../../rendering-commons/Sorting";
var messages = defineMessages({
    main_prematch: {
        id: "main.prematch",
        defaultMessage: "Pre-match Highlights"
    },
    all_sports: {
        id: "grid.all_sports",
        defaultMessage: "Весь спорт"
    }
});
var PreMatchHighlights = /** @class */ (function (_super) {
    __extends(PreMatchHighlights, _super);
    function PreMatchHighlights() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PreMatchHighlights.prototype.render = function () {
        var _this = this;
        var _a = this.props, section = _a.section, gridLocalization = _a.gridLocalization, intl = _a.intl, matches = _a.matches, sportsMenu = _a.sportsMenu;
        var sports = this.props.sports.filter(function (s) { return matches.get("sportId") === s.id; });
        var renderSection = [];
        sports.sort(sportSortFunc).map(function (sport) {
            var eventCount = sportsMenu.getIn([sport.get("id"), "eventCount"]);
            var matches = _this.props.matches.filter(function (m) { return sport.get("id") === m.get("sportId"); });
            renderSection.push(_jsx(Sport, { sport: sport, eventCount: eventCount || 0, matches: matches, section: section, gridLocalization: gridLocalization }, sport.get("id")));
        });
        var totalEvents = 0;
        sportsMenu.map(function (sport) {
            totalEvents += sport.get("eventCount");
        });
        return (_jsxs("div", __assign({ className: "blc blc_best" }, { children: [_jsx("div", __assign({ className: "header" }, { children: intl.formatMessage(messages.main_prematch) })), renderSection, _jsx("div", __assign({ className: "section" }, { children: _jsx(Link, __assign({ to: "/sport", className: "title all_sports" }, { children: _jsxs("div", __assign({ className: "title__name" }, { children: [intl.formatMessage(messages.all_sports), _jsx("span", __assign({ className: "title__badge" }, { children: totalEvents }))] })) })) }))] })));
    };
    return PreMatchHighlights;
}(PureComponent));
PreMatchHighlights.propTypes = {
    gridLocalization: PropTypes.object.isRequired,
    section: PropTypes.string.isRequired,
    sports: PropTypes.object.isRequired,
    matches: PropTypes.object.isRequired,
    sportsMenu: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired
};
function mapStateToProps(state, props) {
    var section = props.section;
    var sports = state.application.getIn([section, "sports"]);
    var sportsMenu = state.application.getIn(["linesMenu", "sports"]);
    var matches = state.application.getIn([section, "matches"]);
    return {
        sports: sports,
        matches: matches,
        sportsMenu: sportsMenu
    };
}
PreMatchHighlights = connect(mapStateToProps, null)(PreMatchHighlights);
export default injectIntl(PreMatchHighlights);



// WEBPACK FOOTER //
// ./src/components/grid/popular/PreMatchHighlights.jsx